import { useSelector } from 'react-redux';

import { showAlert, hideAlert } from '../../Dashboard/actions';
import { getAlert } from '../../Dashboard/selectors';

import useAction from './useAction';

const useAlert = () => {
  const dispatchShowAlert = useAction(showAlert);
  const dispatchHideAlert = useAction(hideAlert);
  const alert = useSelector(getAlert);

  return {
    alert,
    showAlert: dispatchShowAlert,
    hideAlert: dispatchHideAlert,
  };
};

export default useAlert;
